import React, { Component, Fragment } from 'react'
import { Input } from 'loyal-react'
import { SelectAreaCode } from './SelectAreaCode'
import PropTypes from 'prop-types'

import '@loyal_template/recharge.css'

class PhoneNumber extends Component {
  constructor (props) {
    super(props)
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this)
    this.onChangeAreaCode = this.onChangeAreaCode.bind(this)
  }

  onChangePhoneNumber (e) {
    this.props.onChangePhoneNumber({
      areaCode: this.props.areaCode,
      phoneNumber: (e.target && e.target.value) || e.phoneNumber
    })
  }

  onChangeAreaCode (e) {
    this.props.onChangeAreaCode(e)
    this.props.onChangePhoneNumber({
      areaCode: e.value || e.areaCode,
      phoneNumber: this.props.phoneNumber
    })
  }

  render () {
    return (
      <Fragment>
        <div className={this.props.divContentClassName}>
          <div className='row'>
            <SelectAreaCode
              onChangeAreaCode={this.onChangeAreaCode}
              operatorKey={this.props.operatorKey}
              areaCode={this.props.areaCode}
              disabled={this.props.disabled}
              required={this.props.required}
            />
            <Input
              id='telefone'
              className='col-8'
              label='Número de telefone'
              type='text'
              mask={[
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                '-',
                /[0-9]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/
              ]}
              value={this.props.phoneNumber}
              onChange={e => this.onChangePhoneNumber(e)}
              disabled={this.props.disabled}
              required={this.props.required}
            />
          </div>
        </div>
      </Fragment>
    )
  }
}
PhoneNumber.propTypes = {
  divContentClassName: PropTypes.string,
  operatorKey: PropTypes.string,
  onChangeAreaCode: PropTypes.func,
  onChangePhoneNumber: PropTypes.func,
  areaCode: PropTypes.number,
  phoneNumber: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool
}

export default PhoneNumber



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/PhoneNumber/PhoneNumber.js